import { UserHpplusAcademia, UserHpplusOne, UserLee, UserMensMagazine, UserShueishaOnline, UserUomo, UserVJump, UserShueishaPublication, UserShueishaMangasai, UserBetsuma,UserSpur } from "@/commons/interfaces";
import { sidClient } from "@/plugins/auth";
import { QuestionnaireInfo } from "@/modules/questionnaire/questionnaireInfo";
import { toBoolean } from "../commonUtility";
import { store } from "@/store";

// アンケートシステム関連定数定義
/** 許容コールバックURL */
export const QUESTIONNAIRE_ACCEPT_CALLBACK_URLS = process.env.VUE_APP_QUESTIONNAIRE_ACCEPT_CALLBACK_URLS.split(",").map((url: string) => `^${url}(\\?.*)?$`);

// サイト識別ID
export const ALL_LINKAGE_ID = -1;
export const HPPLUS_LINKAGE_ID = 0;
export const HPS_LINKAGE_ID = 1;
export const JCS_LINKAGE_ID = 2;
export const JUMP_NAVI_LINKAGE_ID = 3;
export const HAPIACA_LINKAGE_ID = 4;
export const LEE_LINKAGE_ID = 5;
export const SHUEISHA_MANGASAI_LINKAGE_ID = 6;
export const UOMO_LINKAGE_ID = 7;
export const RIMACOMI_LINKAGE_ID = 8;
export const MENS_MAGAZINE_LINKAGE_ID = 9;
export const SHUEISHA_ONLINE_LINKAGE_ID = 10;
export const VJUMP_LINKAGE_ID = 11;
export const JUMP_LABO_LINKAGE_ID = 12;
export const MANGA_MEE_LINKAGE_ID = 13;
export const SHUEISHA_PUBLICATION_LINKAGE_ID = 14;
export const BETSUMA_LINKAGE_ID = 15;
export const SPUR_LINKAGE_ID = 16;


/** サイトコード（SID全会員を対象としたアンケート） */
export const SITE_CODE_SID_ALL = "ALL";

/**
 * アンケートシステム画面のルート名称クラス
 */
export class QuestionnaireRouteNames {
    public static readonly PARENT = "QuestionnaireParent";
    public static readonly LOGIN = "QuestionnaireLogin";
    public static readonly NEW_PASSWORD = "QuestionnaireNewPassword";
    public static readonly RESET_PASSWORD = "QuestionnaireResetPassword";
    public static readonly SET_PASSWORD = "QuestionnaireSetPassword";
    public static readonly GENERAL_ERROR = "QuestionnaireGeneralError";
}

/**
 * 拡張メルマガIDチェック（ハピプラ用）
 * @param mmExtId
 */
const checkMmExtIdHpplus = async (mmExtId: string) => {

    // サイト固有情報取得
    const response: UserHpplusOne = await sidClient.requestApi({ method: "GET", path: "/hpplus/me" })
        .then(res => res.data)
        .catch(() => new UserHpplusOne());
    // 拡張メルマガIDの指定で判断
    return response.mailmagazine.find(item => item.mailMagazineId === Number(mmExtId) && !item.leaveDate) !== undefined;
};

/**
 * 拡張メルマガIDチェック（メンズマガジン用）
 * @param mmExtId
 */
const checkMmExtIdMensMagazine = async (mmExtId: string) => {
    // サイト固有情報取得
    const response: UserMensMagazine = await sidClient.requestApi({ method: "GET", path: "/mens_magazine/me" })
        .then(res => res.data)
        .catch(() => new UserMensMagazine());
    // 拡張メルマガIDの指定で判断
    return !!(response.mailMagazine) && (response.mailMagazine as any)[mmExtId] === true;
};

/**
 * メルマガフラグチェック（ハピアカ用）
 * @param mmFlg
 */
const checkMmFlgHapiaca = async (mmFlg: string) => {
    // サイト固有情報取得
    const response: UserHpplusAcademia = await sidClient.requestApi({ method: "GET", path: "/hpplus_academia/me" })
        .then(res => res.data)
        .catch(() => new UserHpplusAcademia());
    // メルマガフラグの指定で判断
    return response.mailMagazine?.main === toBoolean(mmFlg);
};

/**
 * メルマガフラグチェック（LEE用）
 * @param mmFlg
 */
const checkMmFlgLee = async (mmFlg: string) => {
    // サイト固有情報取得
    const response: UserLee = await sidClient.requestApi({ method: "GET", path: "/lee/me" })
        .then(res => res.data)
        .catch(() => new UserLee());
    // メルマガフラグの指定で判断
    return response.isSendMailMagazine === toBoolean(mmFlg);
};

/**
 * メルマガフラグチェック（UOMO用）
 * @param mmFlg
 */
const checkMmFlgUomo = async (mmFlg: string) => {
    // サイト固有情報取得
    const response: UserUomo = await sidClient.requestApi({ method: "GET", path: "/uomo/me" })
        .then(res => res.data)
        .catch(() => new UserUomo());
    // メルマガフラグの指定で判断
    return response.isSendMailMagazine === toBoolean(mmFlg);
};

/**
 * メルマガフラグチェック（集英社オンライン用）
 * @param mmFlg
 */
const checkMmFlgShueishaOnline = async (mmFlg: string) => {
    // サイト固有情報取得
    const response: UserShueishaOnline = await sidClient.requestApi({ method: "GET", path: "/shueisha_online/me" })
        .then(res => res.data)
        .catch(() => new UserShueishaOnline());
    // メルマガフラグの指定で判断
    return response.isSendMailMagazine === toBoolean(mmFlg);
};

/**
 * メルマガフラグチェック（Vジャンプ用）
 * @param mmFlg
 */
const checkMmFlgVJump = async (mmFlg: string) => {
    // サイト固有情報取得
    const response: UserVJump = await sidClient.requestApi({ method: "GET", path: "/vjump/me" })
        .then(res => res.data)
        .catch(() => new UserVJump());
    // メルマガフラグの指定で判断
    return response.isSendMailMagazine === toBoolean(mmFlg);
};

/**
 * メルマガフラグチェック（集英社書籍用）
 * @param mmFlg
 */
const checkMmFlgShueishaPublication = async (mmFlg: string) => {
    // サイト固有情報取得
    const response: UserShueishaPublication = await sidClient.requestApi({ method: "GET", path: "/shueisha_publication/me" })
        .then(res => res.data)
        .catch(() => new UserShueishaPublication());
    // メルマガフラグの指定で判断
    return response.isSendMailMagazine === toBoolean(mmFlg);
};

/**
 * メルマガフラグチェック（集英社マンガ祭用）
 * @param mmFlg
 */
const checkMmFlgShueishaMangasai = async (mmFlg: string) => {
    // サイト固有情報取得
    const response: UserShueishaMangasai = await sidClient.requestApi({ method: "GET", path: "/shueisha_mangasai/me" })
        .then(res => res.data)
        .catch(() => new UserShueishaMangasai());
    // メルマガフラグの指定で判断
    return response.isSendMailMagazine === toBoolean(mmFlg);
};

/**
 * メルマガフラグチェック（別冊マーガレット用）
 * @param mmFlg
 */
const checkMmFlgBetsuma = async (mmFlg: string) => {
    // サイト固有情報取得
    const response: UserBetsuma = await sidClient.requestApi({ method: "GET", path: "/betsuma/me" })
        .then(res => res.data)
        .catch(() => new UserBetsuma());
    // メルマガフラグの指定で判断
    return response.isSendMailMagazine === toBoolean(mmFlg);
};

/**
 * メルマガフラグチェック（SPUR用）
 * @param mmFlg
 */
const checkMmFlgSpur = async (mmFlg: string) => {
    // サイト固有情報取得
    const response: UserSpur = await sidClient.requestApi({ method: "GET", path: "/spur/me" })
        .then(res => res.data)
        .catch(() => new UserSpur());
    // メルマガフラグの指定で判断
    return response.isSendMailMagazine === toBoolean(mmFlg);
};

type SiteParam = {
    linkId: number;
    siteCode?: string | null;
    optionChecker: { [key: string]: (val: string) => Promise<boolean> | boolean };
}
/**
 * パラメータ一覧
 */
export const SITE_PARAM_LIST: SiteParam[] = [
    { linkId: ALL_LINKAGE_ID, siteCode: SITE_CODE_SID_ALL, optionChecker: {} },
    { linkId: HPPLUS_LINKAGE_ID, optionChecker: { "mmExtId": checkMmExtIdHpplus }, },
    { linkId: HPS_LINKAGE_ID, optionChecker: {} },
    { linkId: JCS_LINKAGE_ID, optionChecker: {} },
    { linkId: JUMP_NAVI_LINKAGE_ID, optionChecker: {} },
    { linkId: HAPIACA_LINKAGE_ID, optionChecker: { "mmFlg": checkMmFlgHapiaca } },
    { linkId: LEE_LINKAGE_ID, optionChecker: { "mmFlg": checkMmFlgLee } },
    { linkId: UOMO_LINKAGE_ID, optionChecker: { "mmFlg": checkMmFlgUomo } },
    { linkId: RIMACOMI_LINKAGE_ID, optionChecker: {} },
    { linkId: MENS_MAGAZINE_LINKAGE_ID, optionChecker: { "mmExtId": checkMmExtIdMensMagazine } },
    { linkId: SHUEISHA_ONLINE_LINKAGE_ID, optionChecker: { "mmFlg": checkMmFlgShueishaOnline } },
    { linkId: VJUMP_LINKAGE_ID, optionChecker: { "mmFlg": checkMmFlgVJump } },
    { linkId: JUMP_LABO_LINKAGE_ID, optionChecker: {} },
    { linkId: MANGA_MEE_LINKAGE_ID, optionChecker: {} },
    { linkId: SHUEISHA_PUBLICATION_LINKAGE_ID, optionChecker: { "mmFlg": checkMmFlgShueishaPublication }  },
    { linkId: SHUEISHA_MANGASAI_LINKAGE_ID, optionChecker: { "mmFlg": checkMmFlgShueishaMangasai }  },
    { linkId: BETSUMA_LINKAGE_ID, optionChecker: { "mmFlg": checkMmFlgBetsuma }  },
    { linkId: SPUR_LINKAGE_ID, optionChecker: { "mmFlg": checkMmFlgSpur }  },
];


export const SITE_CONFIGS = [
    { linkId: ALL_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: HPPLUS_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: HPS_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: JCS_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: JUMP_NAVI_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: HAPIACA_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: LEE_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: UOMO_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: RIMACOMI_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: MENS_MAGAZINE_LINKAGE_ID, config: {
        isDirectMove: true,
        loginUrl: "/linkage/mens_nonno/login",
        registerUrl: "/linkage/mens_nonno/signup",
        updateAttrUrl: "/linkage/mens_nonno/identification?retUrl=MensNonnoProfileChild",
    } },
    { linkId: SHUEISHA_ONLINE_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: VJUMP_LINKAGE_ID, config: {
        isDirectMove: true,
        loginUrl: "/linkage/vjump/login",
        registerUrl: "/linkage/vjump/signup",
        updateAttrUrl: "/linkage/vjump/identification?retUrl=VJumpProfileChild",
    } },
    { linkId: JUMP_LABO_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: MANGA_MEE_LINKAGE_ID, config: { isDirectMove: false } },
    { linkId: SHUEISHA_PUBLICATION_LINKAGE_ID, config: {
        isDirectMove: true,
        loginUrl: "/linkage/shueisha_publication/login",
        registerUrl: "/linkage/shueisha_publication/signup",
        updateAttrUrl: "/linkage/shueisha_publication/identification?retUrl=ShueishaPublicationProfileChild",
    } },
    { linkId: SHUEISHA_MANGASAI_LINKAGE_ID, config: {
        isDirectMove: true,
        loginUrl: "/linkage/shueisha_mangasai/login",
        registerUrl: "/linkage/shueisha_mangasai/signup",
        updateAttrUrl: "/linkage/shueisha_mangasai/identification?retUrl=ShueishaMangasaiProfileChild",
    } },
    { linkId: BETSUMA_LINKAGE_ID, config: {
        isDirectMove: true,
        loginUrl: "/linkage/betsuma/login",
        registerUrl: "/linkage/betsuma/signup",
        updateAttrUrl: "/linkage/betsuma/identification?retUrl=BetsumaProfileChild",
    } },
    { linkId: SPUR_LINKAGE_ID, config: { isDirectMove: false } },
];

/**
 * 拡張メルマガID一覧（※ハピプラ用）
 */
export const HPPLUS_MM_EXT_ID_LIST = [
    { id: 0, name: "HAPPY PLUS" },
    { id: 1, name: "MORE" },
    { id: 2, name: "MAQUIA" },
    { id: 3, name: "SPUR" },
    { id: 4, name: "BAILA" },
    { id: 5, name: "Marisol" },
    { id: 6, name: "LEE" },
    { id: 7, name: "eclat" },
    { id: 8, name: "nonno" },
    { id: 11, name: "yoi" },
    { id: 12, name: "T JAPAN" }
];

/**
 * 拡張メルマガID一覧（※メンズマガジン用）
 */
export const MENS_MAGAZINE_MM_EXT_ID_LIST = [
    { id: "weeklyPlayboy", name: "週刊プレイボーイ" },
    { id: "webSportiva", name: "web Sportiva" },
    { id: "mensNonNo", name: "MEN'S NON-NO" },
    { id: "mensNonNoBeaut", name: "MEN'S NON-NO BEAUTY" },
];

/**
 * サイト識別コードから連携先IDを取得
 * @param siteCode サイト識別コード
 * @returns
 */
export const getLinkIdFromSiteCode = (siteCode: string) => {
    if (siteCode === SITE_CODE_SID_ALL) {
        return ALL_LINKAGE_ID;
    }
    return store.state.siteLinkage.find(site => site.site_code === siteCode)?.link_id as number;
};

/**
 * メールマガジン名取得
 * @param linkId 連携先ID
 * @param mmExtId 拡張メルマガID（オプショナル）
 */
export const getMailMagazineName = (linkId: number, mmExtId: string | null) => {
    if (linkId === HPPLUS_LINKAGE_ID) {
        return HPPLUS_MM_EXT_ID_LIST.find(item => item.id === Number(mmExtId))?.name;
    } else if (linkId === MENS_MAGAZINE_LINKAGE_ID) {
        return MENS_MAGAZINE_MM_EXT_ID_LIST.find(item => item.id === mmExtId)?.name;
    }
    return store.state.siteLinkage.find(site => site.link_id === linkId)?.name;
};

/**
 * クエリパラメータチェック
 * @param questionnaireInfo
 */
export const checkQueryParams = (questionnaireInfo: QuestionnaireInfo) => {
    const linkId = getLinkIdFromSiteCode(questionnaireInfo.siteCode);
    const siteParam = SITE_PARAM_LIST.find(param => param.linkId === linkId);
    if (linkId !== ALL_LINKAGE_ID) {
        // サイト識別コードが不正の場合
        if (!store.state.siteLinkage.find(site => site.site_code === questionnaireInfo.siteCode)) {
            return false;
        }
    }
    // mmFlgが指定されているが、許容されていない場合
    if (questionnaireInfo.mmFlg !== null && !siteParam?.optionChecker["mmFlg"]) {
        return false;
    }
    // mmExtIdが指定されているが、許容されていない場合
    if (questionnaireInfo.mmExtId !== null && !siteParam?.optionChecker["mmExtId"]) {
        return false;
    }
    return true;
};

/**
 * アンケート資格を有するかチェック
 * @param linkId 連携先ID
 * @param questionnaireInfo アンケート情報
 * @returns ture：該当する、false：該当しない
 */
export const isQualified = async (linkId: number, questionnaireInfo: QuestionnaireInfo) => {
    // サイト毎のパラメータ情報を取得
    const siteParam = SITE_PARAM_LIST.find(param => param.linkId === linkId);
    if (!siteParam) {
        return false;
    }

    // 拡張メルマガIDが指定されている場合のチェック処理
    if (questionnaireInfo.mmExtId !== null) {
        const result = await siteParam.optionChecker["mmExtId"](questionnaireInfo.mmExtId);
        if (!result) return false;
    }
    // メルマガフラグが指定されている場合のチェック処理
    if (toBoolean(questionnaireInfo.mmFlg)) {
        const result = await siteParam.optionChecker["mmFlg"]("true");
        if (!result) return false;
    }
    return true;
};
